"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LoginSceneTranslation = {
    fi: {
        LoginScene: {
            title: 'Kirjaudu',
            subTitle: 'Täytä tiedot ja kirjaudu sisään',
            email: 'Sähköposti',
            username: 'Käyttäjänimi',
            password: 'Salasana',
            forgotPassword: 'Unohditko salasanasi?',
            register: 'Oletko uusi? Luo tunnus!',
            button: 'Kirjaudu',
        },
    },
    en: {
        LoginScene: {
            title: 'Login',
            subTitle: 'Fill form and login',
            email: 'Email',
            username: 'Username',
            password: 'Password',
            forgotPassword: 'Forgot password?',
            register: 'New? Create new account!',
            button: 'Login',
        },
    },
};
exports.default = LoginSceneTranslation;
//# sourceMappingURL=LoginScene.translation.js.map